export function numberFromText(text: string) {
  // numberFromText("AA");
  const charCodes = (text || '')
    .split('') // => ["A", "A"]
    .map((char) => char.charCodeAt(0)) // => [65, 65]
    .join('') // => "6565"
  return parseInt(charCodes, 10)
}
